import styled from "styled-components";

export const PortfolioContainer = styled.article`
  padding: 0 2.4rem;
  margin-bottom: 1.6rem !important;
  @media screen and (min-width: 768px) {
    padding: 0;
  }
`;
